import api from "./api";

export const getLatestAlarm = async () => {
  try {
    const response = await api.get(
      "/latest_alarm"
    );

    return response.data;
  } catch (error) {
    console.log("Latest Alarm API Error", error);

    throw error;
  }
};

export const getDashboardSummary =
  async () => {
    try {
      const response = await api.get(
        "/dashboard-summary"
      );

      return response.data;
    } catch (error) {
      console.log(
        "Dashboard Summary API Error",
        error
      );

      throw error;
    }
  };

  export const getHistoryData =
  async (
    year,
    month,
    day
  ) => {
    try {
      const response = await api.get(
        "/history",
        {
          params: {
            year,
            month,
            day,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.log(
        "History API Error",
        error
      );

      throw error;
    }
  };

  export const getAllAlarms =
  async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_DASHBOARD_URL}/all_alarms`
      );

      return response.data;
    } catch (error) {
      console.log(
        "All Alarms API Error",
        error
      );

      throw error;
    }
  };

  export const getHeatmapData =
  async () => {
    try {
      const response =
        await api.get(
          "/heatmap"
        );

      return response.data;
    } catch (error) {
      console.log(
        "Heatmap API Error",
        error
      );

      throw error;
    }
  };

  export const getDevicesByTimeRange =
  async (timeRange) => {

    try {

      const response =
        await api.get(
          "/devices",
          {
            params: {
              timeRange,
            },
          }
        );

      return response.data;

    } catch (error) {

      console.log(
        "Devices API Error",
        error
      );

      throw error;
    }
  };

  export const getAllMsgDetails =
  async (
    msgType,
    timeRange
  ) => {

    try {

      const response =
        await api.get(
          "/all_MsgDetails",
          {
            params: {
              msgType,
              timeRange,
            },
          }
        );

      return response.data;

    } catch (error) {

      console.log(
        "All Msg Details API Error",
        error
      );

      throw error;
    }
  };

  //Door Alaram API Calls
  export const getLatestAlarmPerDevice = async () => {
    try {
      const response = await api.get("/latest_alerts_deviceID", {
        params: {
          msgType: "Door Lock sensor",
          timeRange: "24h",
        },
      });
  
      return response.data;
    } catch (error) {
      console.log("Latest Alarm Per Device API Error", error);
      throw error;
    }
  };

  export const getDoorEventsByHour = async () => {
    try {
      const response = await api.get("/door-monitoring/events-by-hour");
  
      return response.data;
    } catch (error) {
      console.error("Door Events By Hour API Error", error);
      throw error;
    }
  };